import styled from 'styled-components';
import { formContainerStyles, formGroupStyles } from '../style';

export const UpdatePasswordStyles = styled.div`
  .update-password-container {
    ${formContainerStyles}
  }

  ${formGroupStyles}

  .form-label {
    display: flex;
    gap: 10px;
  }
`;
